import './Welcome.scss';
export class WelcomeController {
    static $inject = ['ngToast', 'LoadingService', 'application', 'WelcomeService', 'MessagingHubService', '$window', '$scope', '$rootScope', '$translate'];
    constructor(ngToast, LoadingService, application, WelcomeService, MessagingHubService, $window, $scope, $rootScope, $translate) {
        'ngInject';
        this.ngToast = ngToast;
        this.LoadingService = LoadingService;
        this.application = application;
        this.WelcomeService = WelcomeService;
        this.MessagingHubService = MessagingHubService;
        this.$translate = $translate;
        this.onGreetingChange = (event) => {
            const newGreeting = event.detail.value;
            this.greeting = newGreeting;
        };
        this.onGetStartedLabelChange = (event) => {
            const newGetStartedLabel = event.detail.value;
            this.getStartedLabel = newGetStartedLabel;
        };
        this.onGetStartedChange = (event) => {
            const newGetStarted = event.detail.value;
            this.getStarted = newGetStarted;
        };
        this.formIsValid = async () => {
            const inputs = document.querySelectorAll('bds-input.welcome-form-input');
            for (const input of Array.from(inputs)) {
                const isValid = await input.isValid();
                if (!isValid) {
                    return false;
                }
            }
            return true;
        };
        this.isActive = false;
        this.init();
        //Window/scope methods
        $window.onbeforeunload = this.alertPendingChanges.bind(this, true);
        $scope.$on('$stateChangeStart', this.alertPendingChanges.bind(this, false));
        $scope.$on('$destroy', () => ($window.onbeforeunload = undefined));
    }
    async init() {
        this.LoadingService.startLoading();
        try {
            this.greeting = await this.WelcomeService.getGreeting(this.application);
            this.getStarted = await this.WelcomeService.getGetStarted(this.application);
            this.getStartedLabel = await this.WelcomeService.getGetStartedLabel(this.application);
            this.getAccountData();
            // this.botName = this.botAccount.displayName;
        }
        catch (err) {
            const errorMessage = await this.$translate('utils.errorMsg.3');
            this.ngToast.danger(errorMessage);
            this.saveError = err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
        if (this.greeting || this.getStarted || this.getStartedLabel) {
            this.isActive = true;
        }
    }
    async getAccountData() {
        const defaultComponentsColor = '#2CC3D5';
        this.botAccount = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `lime://msging.net/accounts/${this.application.shortName}`,
        });
        const componentColor = this.botAccount.extras['blipchat-components-color'] ||
            defaultComponentsColor;
        const sheet = document.createElement('style');
        sheet.innerHTML =
            `.foo-blip-chat-start {
                background-color: ${componentColor}!important;
                border-color: ${componentColor}!important;
            }`;
        document.body.appendChild(sheet);
        this.botName = this.botAccount.extras['blipchat-display-name'] || this.application.name;
    }
    async onToggle(value) {
        if (value) {
            this.isActive = true;
            return;
        }
        try {
            const successMessage = await this.$translate('utils.successMsg.8');
            // Try ti delete postback-message first in case of Facebook error
            await this.WelcomeService.deleteGetStarted(this.application);
            const saveGreetingPromise = this.WelcomeService.deleteGreeting(this.application);
            const saveGetStartedLabelPromise = this.WelcomeService.deleteGetStartedLabel(this.application);
            await Promise.all([saveGreetingPromise, saveGetStartedLabelPromise]);
            this.greeting = undefined;
            this.getStarted = undefined;
            this.getStartedLabel = undefined;
            this.ngToast.success(successMessage);
            this.isActive = false;
        }
        catch (err) {
            this.isActive = !value;
            const errorMessage = await this.$translate('utils.errorMsg.4');
            this.ngToast.danger(errorMessage);
            this.saveError = err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async save() {
        const validForm = await this.formIsValid();
        if (!validForm) {
            const errorMessage = await this.$translate('utils.errorMsg.116');
            this.ngToast.danger(errorMessage);
            return;
        }
        this.LoadingService.startLoading();
        try {
            const saveGreetingPromise = this.WelcomeService.saveGreeting(this.application, this.greeting);
            const saveGetStartedLabelPromise = this.WelcomeService.saveGetStartedLabel(this.application, this.getStartedLabel);
            const saveGetStartedPromise = this.WelcomeService.saveGetStarted(this.application, this.getStarted);
            await Promise.all([saveGreetingPromise, saveGetStartedPromise, saveGetStartedLabelPromise]);
            const successMessage = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMessage);
            this.welcomeForm.$setPristine();
        }
        catch (err) {
            const errorMessage = await this.$translate('utils.errorMsg.4');
            this.ngToast.danger(errorMessage);
            this.saveError = err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    alertPendingChanges(isWindowClosing, e) {
        this.LoadingService.stopLoading();
        if (!this.welcomeForm ||
            !this.welcomeForm.$dirty) {
            return;
        }
        const message = this.$translate.instant('modules.application.detail.persistentMenu.confirmationMessage');
        if (!isWindowClosing && !e.defaultPrevented && !confirm(message)) {
            e.preventDefault();
            return false;
        }
        e.returnValue = message;
        return message;
    }
}
WelcomeController.$inject = ['ngToast', 'LoadingService', 'application', 'WelcomeService', 'MessagingHubService', '$window', '$scope', '$rootScope', '$translate'];
